module.exports = __webpack_public_path__ + "img/Loading_r_4.fdfc2ca8.png";